module.exports = __webpack_public_path__ + "img/Platform-c.96d3e34.svg";